// Active / Inactive pill used by the Service Professionals tables and the
// Animal Health Facilities table ("Professional Status" column)
export default function ProfessionalStatusBadge({ status }) {
  const isActive = status === 'Active';
  return (
    <span
      className="inline-flex items-center justify-center rounded-full px-[12px] py-[5px] text-[11px] font-medium"
      style={{
        background: isActive ? 'rgba(31,193,107,0.1)' : 'rgba(156,163,175,0.15)',
        color:      isActive ? '#1fc16b' : '#9ca3af',
      }}
    >
      {status}
    </span>
  );
}
